import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, TruckIcon, ShieldIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-100 pt-12 pb-6" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-22">
          <div data-id="element-23">
            <h3 className="text-lg font-semibold mb-4" data-id="element-24">
              <span className="text-green-500" data-id="element-25">Tech</span>
              <span className="text-amber-500" data-id="element-26">Gold</span>
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-27">
              Your trusted marketplace for high-quality used electronics and
              investment-grade precious metals.
            </p>
          </div>
          <div data-id="element-28">
            <h3 className="text-lg font-semibold mb-4" data-id="element-29">Shop</h3>
            <ul className="space-y-2" data-id="element-30">
              <li data-id="element-31">
                <Link to="/shop?category=electronics" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-32">
                  Used Tech
                </Link>
              </li>
              <li data-id="element-33">
                <Link to="/shop?category=gold" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-34">
                  Gold
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/shop?category=silver" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-36">
                  Silver
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/shop?category=platinum" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-38">
                  Platinum
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-39">
            <h3 className="text-lg font-semibold mb-4" data-id="element-40">Company</h3>
            <ul className="space-y-2" data-id="element-41">
              <li data-id="element-42">
                <Link to="/about" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-43">
                  About Us
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/contact" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-45">
                  Contact
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/privacy" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-47">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/terms" className="text-gray-600 hover:text-green-500 transition-colors" data-id="element-49">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-50">
            <h3 className="text-lg font-semibold mb-4" data-id="element-51">Contact</h3>
            <ul className="space-y-2" data-id="element-52">
              <li className="flex items-center text-gray-600" data-id="element-53">
                <PhoneIcon size={16} className="mr-2" data-id="element-54" />
                <span data-id="element-55">(555) 123-4567</span>
              </li>
              <li className="flex items-center text-gray-600" data-id="element-56">
                <MailIcon size={16} className="mr-2" data-id="element-57" />
                <span data-id="element-58">support@techgold.com</span>
              </li>
              <li className="flex items-center text-gray-600" data-id="element-59">
                <MapPinIcon size={16} className="mr-2" data-id="element-60" />
                <span data-id="element-61">123 Market St, San Francisco, CA</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6 mt-8" data-id="element-62">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-63">
            <div className="flex items-center space-x-4 mb-4 md:mb-0" data-id="element-64">
              <div className="flex items-center text-gray-600" data-id="element-65">
                <CreditCardIcon size={16} className="mr-2" data-id="element-66" />
                <span data-id="element-67">Secure Payment</span>
              </div>
              <div className="flex items-center text-gray-600" data-id="element-68">
                <TruckIcon size={16} className="mr-2" data-id="element-69" />
                <span data-id="element-70">Fast Shipping</span>
              </div>
              <div className="flex items-center text-gray-600" data-id="element-71">
                <ShieldIcon size={16} className="mr-2" data-id="element-72" />
                <span data-id="element-73">Warranty</span>
              </div>
            </div>
            <p className="text-gray-600 text-sm" data-id="element-74">
              &copy; {new Date().getFullYear()} TechGold. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};